export default __webpack_public_path__ + "static/media/padlock.50cdbe7e.svg";